/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamExterniSystem extends GContentBase<SeznamExterniSystemObj> {
        private seznamObj: SeznamExterniSystemObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamExterniSystemObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamExterniSystem",
                contentCaption: "jres:33000265", //RC 33000265 : Externí systémy
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{post_sluzba}"
                },
                gridSettings: {
                    columnOrder: "ico,ixs_ext,nazev,zmenu_prov_txt,dat_zmena"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamExterniSystemObj extends GAdmSeznamBase {
        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailExterniSystem", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID:"DetailExterniSystem",
                newRecord: isNew,
                ixs_ext: isNew == true ? null : data.ixs_ext
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*"]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*"])
        }

        createFilterForm() {
            
        }

        userhardDefaultFilter(hardFilter: any): any {
            return hardFilter;
        }

        collectData(data: any) {

        }

        applydata(filterData: any) {
            this.cnt.isl.ExterniSystem.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {

        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}".format(data.ixs_ext),
                nazev: ""
            }
        }
    }
}